module.exports = __webpack_public_path__ + "static/media/found-tree.34f0a66f.svg";